import { createApp } from 'vue';
import { createPinia } from 'pinia'
import App from './App.vue';
import { router } from './router';
import VueClipboards from 'vue-clipboards';
import 'vant/lib/index.css';
import { Popup, Overlay, Tab, Tabs, Icon, Dialog, List, NavBar, ImagePreview, DatePicker, PullRefresh, RollingText, Swipe, SwipeItem, TextEllipsis, Popover, NoticeBar } from 'vant';
// import Vconsole from 'vconsole'

const pinia = createPinia()
const app = createApp(App);

app.directive('longpress', {
    beforeMount(el, binding) {
        if (typeof binding.value !== 'function') {
            throw 'callback must be a function';
        }
        let pressTimer = null;
        const start = (e) => {
            if (e.type === 'click' && e.button !== 0) return;
            if (pressTimer === null) {
                pressTimer = setTimeout(() => {
                    handler();
                }, 800);
            }
        };
        const cancel = () => {
            if (pressTimer !== null) {
                clearTimeout(pressTimer);
                pressTimer = null;
            }
        };
        const handler = (e) => {
            binding.value(e);
        };
        el.addEventListener('mousedown', start);
        el.addEventListener('touchstart', start);
        el.addEventListener('click', cancel);
        el.addEventListener('mouseout', cancel);
        el.addEventListener('touchend', cancel);
        el.addEventListener('touchcancel', cancel);
    }
});
// if (process.env.NODE_ENV == 'test' || process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'staging') { // 测试和开发打开，生产不能打开
//   let vConsole = new Vconsole()
//   app.use(vConsole)
// }
app.use(pinia)
app.use(Popup).use(Overlay).use(Tab).use(Tabs).use(Icon).use(Dialog).use(List).use(NavBar).use(ImagePreview)
.use(DatePicker).use(PullRefresh).use(RollingText).use(Swipe).use(SwipeItem).use(TextEllipsis).use(Popover).use(NoticeBar);
app.use(VueClipboards)
app.use(router);
app.mount('#app');
